import { render, staticRenderFns } from "./shipInformation.vue?vue&type=template&id=df271370&scoped=true"
import script from "./shipInformation.vue?vue&type=script&lang=js"
export * from "./shipInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df271370",
  null
  
)

export default component.exports